import * as ngCore from '@angular/core'

import * as state from '../../../../../../../state'

import * as graph from './graph'
import * as nodePanel from './node-panel'
import { Store } from './store'
import * as tools from './tools'

/**
 * Modal used to deploy Quiver resources
 */
@ngCore.Component({
  imports: [graph.Component, tools.Component, nodePanel.Component],
  providers: [Store],
  selector: 'atn-summit-org-chart',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component implements ngCore.OnDestroy, ngCore.AfterViewInit {
  /** @see {@link Store} */
  public readonly store = ngCore.inject(Store)

  /**
   * {@link state.summit.orgChart.models.OrgChart.Id} that determines which
   * {@link state.summit.orgChart.models.OrgChart} is presented in this
   * {@link Component}
   */
  public readonly orgChartIdSg =
    ngCore.input.required<state.summit.orgChart.models.OrgChart.Id>({
      alias: 'orgChartId',
    })
  /**
   * Writes {@link orgChartIdSg} to {@link Store}
   */
  private readonly _setOrgChartIdInStoreEffect = ngCore.effect(() => {
    const orgChartId = this.orgChartIdSg()
    this.store.patchState({ orgChartId })
  })

  /**
   * After view init we want to call a cleanup to make the current org chart fit
   * into the split screen
   */
  public ngAfterViewInit(): void {
    // TODO: Find a better way to do this without having to put 200ms timeout.
    // I've tried using afterNextRender hook, but it doesn't work, in
    // documentation it says they don't guarantee that the hydration is finished
    // upon callback
    setTimeout(
      () =>
        this.store.orgChartFeature.actions.cleanUp
          .from('OrgChart.setOrgChartIdInStoreEffect')
          .dispatch({ orgChartId: 'current' }),
      200,
    )
  }

  /**
   * Used to cleanup anything that was created for this org chart (primaril
   * cytoscape)
   */
  public ngOnDestroy(): void {
    this.store.orgChartFeature.actions.destroy
      .from('OrgChart.ngOnDestroy')
      .dispatch({
        orgChartId: this.orgChartIdSg(),
      })
  }
}
